module.exports = __webpack_public_path__ + "static/media/twitter-icon.81cf94cc.png";